<template>
  <div class="content-assets-wrapper" data-qa="content-assets-wrapper">
    <el-row data-qa="content-assets-row">
      <el-col :xs="9" :sm="9" :md="8" :lg="6" data-qa="content-assets-sidebar">
        <game-campaign-content-nav
          :menu-items="navigation"
          :default-active="activeItemTitle"
          @update="setActiveItem"
          data-qa="content-assets-navigation"
        />
      </el-col>

      <el-col :xs="15" :sm="15" :md="16" :lg="18" data-qa="content-assets-main">
        <component
          v-if="activeItem"
          :is="activeItem.component"
          :is-creation-mode="isCreationMode"
          :is-read-only="isReadOnly"
          :save-flag="saveFlag"
          :game-campaign-id="gameCampaignId"
          data-qa="content-assets-active-component"
          @goToNextStep="goToNextStep"
          @checkChanges="checkChanges"
          @noChangesSubmit="handleNoChangesSubmit"
          :is-completed="activeItem.isCompleted"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { EventBus } from '@/core/EventBus'
import { customConfirm } from '@/core/helpers'
import GameCampaignContentNav from '@/modules/gamification/components/games-campaigns/GameCampaignContentNav.vue'
import GameStepContentForm from '@/modules/gamification/components/games-campaigns/content-assets/GameStepContentForm.vue'
import GameStepAssets from '@/modules/gamification/components/games-campaigns/content-assets/GameStepAssets.vue'
import { GameCreationSubSteps } from '@/modules/gamification/enum/GameCreationStepsEnum.js'
import { updateNavigationState } from '@/modules/gamification/helpers'

export default {
  name: 'GameStepContentAssets',

  components: {
    GameCampaignContentNav,
    GameStepContentForm,
    GameStepAssets
  },

  props: {
    completedSubSteps: {
      type: Array,
      required: true
    },
    currentSubStep: {
      type: String,
      default: GameCreationSubSteps.CONTENT
    },
    isCreationMode: {
      type: Boolean,
      required: true
    },
    isReadOnly: {
      type: Boolean,
      required: true
    },
    saveFlag: {
      type: Boolean,
      required: true
    },
    gameCampaignId: {
      type: Number
    }
  },

  data() {
    return {
      activeItem: null,
      navigation: [
        {
          title: this.$t('Gamification_Content'),
          step: GameCreationSubSteps.CONTENT,
          component: GameStepContentForm,
          isCompleted: false,
          disabled: false
        },
        {
          title: this.$t('Gamification_Assets'),
          step: GameCreationSubSteps.ASSETS,
          component: GameStepAssets,
          isCompleted: false,
          disabled: false
        }
      ],
      hasChanges: false
    }
  },

  computed: {
    activeItemTitle() {
      return this.activeItem ? this.activeItem.title : null
    }
  },
  mounted() {
    this.updateNavigation()
    this.$emit('check', false)
  },
  watch: {
    currentSubStep() {
      this.updateNavigation()
    }
  },
  methods: {
    handleNoChangesSubmit(currentStep) {
      customConfirm(
        this.$t('Gamification_No_Content_Changes_Title'),
        this.$t('Gamification_No_Content_Changes_Subtitle'),
        this.$t('Gamification_Continue_To_Assets'),
        this.$t('Gamification_Back_To_Content')
      ).then(() => {
        this.goToNextStep(currentStep)
      })
    },
    setActiveItem(tab) {
      if (!this.hasChanges) {
        this.activeItem = tab
        return
      }
      customConfirm(
        this.$t('Gamification_LeavingWithoutSaving'),
        this.$t('Gamification_LeavingWithoutSavingDescription'),
        this.$t('Gamification_Confirm_Button_Leave')
      ).then(() => {
        this.activeItem = tab
      })
    },
    updateNavigation() {
      this.activeItem =
        this.navigation.find(item => item.step === this.currentSubStep) ||
        this.navigation[0]

      if (this.isCreationMode) {
        updateNavigationState(
          this.navigation,
          this.completedSubSteps,
          this.currentSubStep
        )
      }
    },
    goToNextStep(step) {
      const stepIndex = this.navigation.findIndex(item => item.step === step)
      const isLastStep = stepIndex + 1 === this.navigation.length
      if (stepIndex !== -1 && isLastStep) {
        EventBus.$emit('campaign-create-next-step')
      }
      EventBus.$emit('updateStep', step)
    },
    checkChanges(payload) {
      this.hasChanges = payload
      this.$emit('checkChanges', payload)
    }
  }
}
</script>

<style scoped>
.content-assets-wrapper {
  padding-bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/pages/GameStepContentAssets.vue